import { i18n } from '@/locales';
const t = i18n.t.bind(i18n);
const lc = 'views.store_management_fee_by_section.';
export const storeManagementFeeBySectionTableHeader = [
    {
        title: t(`${lc}table.monthly_delivery_start_count`),
        align: 'end',
        sortable: false,
    },
    {
        title: t(`${lc}table.monthly_delivery_end_count`),
        align: 'end',
        sortable: false,
    },
    {
        title: t(`${lc}table.monthly_basic_fee`),
        align: 'end',
        sortable: false,
    },
    {
        title: t(`${lc}table.add_charge`),
        align: 'end',
        sortable: false,
    },
    {
        title: t(`${lc}table.fee_setting`),
        align: 'center',
        width: 112,
        sortable: false,
    },
];
export const addFeeTypeCode = [
    'BASIC_ADD_TYPE',
    'INCREASE_TYPE',
];
export const storeManagementFeeAddOptionList = addFeeTypeCode.map((value) => ({
    text: t(`${lc}table.${value.toLocaleLowerCase()}`),
    value,
}));
